import React from 'react';
import { PropTypes } from 'prop-types';
import { map } from 'lodash';
import { FormattedMessage } from 'react-intl';

import {
  TextContainer, StepperContainer, SkewedButton, IndexContainer,
} from './components';

const Stepper = ({
  name, steps, currentStep, onClick, showStepNumber, mobile, minWidth,
}) => (
  <StepperContainer>
    {map(steps, (step, index) => (
      <SkewedButton
        first={index === 0}
        last={steps.length !== 1 && index === steps.length - 1}
        active={currentStep === index + 1}
        key={`Stepper.${index}`}
        onClick={() => onClick(index + 1)}
        minWidth={minWidth}
      >
        <TextContainer active={currentStep === index + 1}>
          {showStepNumber && <span>{index + 1}</span>}
          {showStepNumber && !mobile && <IndexContainer>.</IndexContainer>}
          {!mobile && <FormattedMessage id={`${name}.${step.textId}`} />}
        </TextContainer>
      </SkewedButton>
    ))}
  </StepperContainer>
);

Stepper.propTypes = {
  name: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  currentStep: PropTypes.number,
  onClick: PropTypes.func,
  showStepNumber: PropTypes.bool,
  mobile: PropTypes.bool,
  minWidth: PropTypes.string,
};

Stepper.defaultProps = {
  onClick: () => null,
  steps: [{ textId: 'StepOne' }, { textId: 'StepTwo' }, { textId: 'StepThree' }],
  currentStep: 1,
  showStepNumber: true,
  mobile: false,
  minWidth: '',
};

export default Stepper;
